import { createAction } from 'shared/utils';

export const CONFIRM_CHANGE_STATUS_AMENITIES_ORDER = {
  APPROVES: createAction('CONFIRM_CHANGE_STATUS_AMENITIES_ORDER_APPROVES'),
  REJECTS: createAction('CONFIRM_CHANGE_STATUS_AMENITIES_ORDER_REJECTS'),
};
